import React from "react";

const Subtitle = ({ children }) => <h2 className="subtitle">{children}</h2>;

export default Subtitle;
